/*
 Preloaded sprites that represents hexadecimal digits from 0 through F.
 Since this is stored in memory, the width of the sprite is 8 bits (size of the memory address)
 Each sprite is 5 bytes long (8x5 pixels)
 The font data should be stored from 0x000 to 0x1FF
*/
export default [ 
// 0
0xF0,
0x90,
0x90,
0x90,
0xF0,
// 1
0x20,
0x60,
0x20,
0x20,
0x70,
// 2
0xF0,
0x10,
0xF0,
0x80,
0xF0,
// 3
0xF0,
0x10,
0xF0,
0x10,
0xF0,
// 4
0x90,
0x90,
0xF0,
0x10,
0x10,
// 5
0xF0,
0x80,
0xF0,
0x10,
0xF0,
// 6
0xF0,
0x80,
0xF0,
0x90,
0xF0,
// 7
0xF0,
0x10,
0x20,
0x40,
0x40,
// 8
0xF0,
0x90,
0xF0,
0x90,
0xF0,
// 9
0xF0,
0x90,
0xF0,
0x10,
0xF0,
// A
0xF0,
0x90,
0xF0,
0x90,
0x90,
// B
0xE0,
0x90,
0xE0,
0x90,
0xE0,
// C
0xF0,
0x80,
0x80,
0x80,
0xF0,
// D
0xE0,
0x90,
0x90,
0x90,
0xE0,
// E
0xF0,
0x80,
0xF0,
0x80,
0xF0,
// F
0xF0,
0x80,
0xF0,
0x80,
0x80
 ];
